export default __webpack_public_path__ + "static/media/invest-mobile.38605f62.svg";